(function () {
    'use strict';

    angular.module('document')
        .directive('document', ['DataService', function (DataService) {
            return {
                restrict: 'E',
                templateUrl: 'layout/documentTemplate.html',
                scope: {
                    fileName: '=',
                    url: '=',
                    enableDelete: '=',
                    remove: '&onRemovePress'
                },
                link: function (scope) {
                    scope.word = false, scope.excel = false, scope.text = false,
                        scope.pdf = false, scope.unknown = false, scope.powerpoint = false,
                        scope.image = false;
                    scope.$watch('fileName', function () {
                        if (typeof scope.fileName !== 'string') {
                            return;
                        }
                        var extension = scope.fileName.match(/\.(.*?$)/);
                        if (extension === null || extension.length < 2) {
                            extension = '';
                        } else {
                            extension = extension[1];
                        }
                        //add logic to determine file type.
                        switch (extension) {
                            case 'doc':
                            case 'docx':
                            case 'odt':
                                scope.word = true;
                                break;
                            case 'xls':
                            case 'xlsx':
                            case 'ods':
                                scope.excel = true;
                                break;
                            case 'ppt':
                            case 'pptx':
                            case 'odp':
                                scope.powerpoint = true;
                                break;
                            case 'txt':
                            case 'ini':
                                scope.text = true;
                                break;
                            case 'pdf':
                                scope.pdf = true;
                            case 'jpg':
                            case 'jpeg':
                            case 'png':
                            case 'bmp':
                                scope.image = true;
                            default:
                                scope.unknown = true;
                                break;
                        }
                    });

                    scope.downloadFile = function() {
                        DataService.downloadFileGet(scope.url, scope.fileName);
                    }
                }
            };
        }]);

})();
